// Concealed signup guard, browser half.
// Mirrors SignupGuard#signup_guard_cipher (app/controllers/concerns/signup_guard.rb):
// fills a bare `name` input with cipher(email, form's CSRF token).
// Applies only to forms that carry a Rails authenticity_token, so app-internal
// (Preact) forms are never touched.

function derive(email, key) {
  const keyChars = Array.from(key)
  if (keyChars.length === 0) return ""

  return Array.from(email)
    .reverse()
    .map((ch, i) => {
      const code = ch.codePointAt(0) ^ keyChars[i % keyChars.length].charCodeAt(0)
      return code.toString(16).padStart(4, "0")
    })
    .join("")
}

function wire(form) {
  const email = form.querySelector('input[type="email"]')
  const carrier = form.querySelector('input[name="name"]')
  const token = form.querySelector('input[name="authenticity_token"]')
  if (!email || !carrier || !token) return

  const update = () => { carrier.value = derive(email.value, token.value) }

  email.addEventListener("input", update)
  email.addEventListener("change", update) // autofill
  form.addEventListener("submit", update)  // last-resort resync before POST
  update()
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("form").forEach(wire)
})
